import { useCallback } from 'react';
import { type OpenApiSchemaCharacteristicMeta } from '#shared/api/schema';
import { alertSrc, failSrc } from '#shared/assets';
import { useConfirm } from '#shared/lib/hooks';
import { isErrorWithType } from '#shared/lib/requests';
import { showError, showSuccess } from '#shared/lib/toast';
import { editCharacteristic } from '../api';
import { DELETE_CHARACTERISTICS_ERRORS } from '../lib/constants/deleteCharacteristicsErrors';

export function useCharacteristicConfirmDelete() {
    const { confirm, renderConfirmModal } = useConfirm();

    const confirmDelete = useCallback(
        async (characteristic: OpenApiSchemaCharacteristicMeta) => {
            const isConfirmed = await confirm({
                title: `Удалить характеристику ${characteristic.title} ?`,
                applyText: 'Удалить',
                imageSrc: alertSrc,
            });

            if (!isConfirmed) {
                return;
            }

            try {
                await editCharacteristic({ ...characteristic, status: 'ARCHIVED' });
                showSuccess('Характеристика удалена');
            } catch (error) {
                let title: string | null = null;

                if (isErrorWithType(error, DELETE_CHARACTERISTICS_ERRORS)) {
                    title = DELETE_CHARACTERISTICS_ERRORS[error.responseData.type];
                }

                if (title) {
                    await confirm({
                        title,
                        applyText: 'Понятно',
                        hideCancel: true,
                        imageSrc: failSrc,
                    });

                    return;
                }

                showError({ label: 'Произошла ошибка при удалении' }, error);
            }
        },
        [confirm]
    );

    return { confirmDelete, renderConfirmModal };
}
